// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOrganizationShortDto
 */
export interface IOrganizationShortDto {
    /**
     * 
     * @type {number}
     * @memberof IOrganizationShortDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationShortDto
     */
    short_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationShortDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationShortDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationShortDto
     */
    path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationShortDto
     */
    is_organization_locked?: boolean;
}

/**
 * Check if a given object implements the IOrganizationShortDto interface.
 */
export function instanceOfIOrganizationShortDto(value: object): value is IOrganizationShortDto {
    return true;
}

export function IOrganizationShortDtoFromJSON(json: any): IOrganizationShortDto {
    return IOrganizationShortDtoFromJSONTyped(json, false);
}

export function IOrganizationShortDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationShortDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'short_name': json['short_name'] == null ? undefined : json['short_name'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'name': json['name'] == null ? undefined : json['name'],
        'path': json['path'] == null ? undefined : json['path'],
        'is_organization_locked': json['is_organization_locked'] == null ? undefined : json['is_organization_locked'],
    };
}

export function IOrganizationShortDtoToJSON(json: any): IOrganizationShortDto {
    return IOrganizationShortDtoToJSONTyped(json, false);
}

export function IOrganizationShortDtoToJSONTyped(value?: IOrganizationShortDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'short_name': value['short_name'],
        'external_identifier': value['external_identifier'],
        'name': value['name'],
        'path': value['path'],
        'is_organization_locked': value['is_organization_locked'],
    };
}

